import Vue from "vue";
import hUrl from "@/utils/url"
import $ from "jquery";
import {ajax} from "@/api/jqajax";
//import CityTree from "@/utils/ChineseCityTree.js";
import Checker, {Reger} from "@/utils/CheckValue";
import Editors from './editors';
function createCityTree(list) {
  var ret = [];
  let id = 0;
  $.each(list, (i, pro) => {
    pro.value = id++;
    pro.label = pro.name;
    pro.leaf = (pro.children || []).length == 0;
    $.each(pro.children, function (j, city) {
      city.value = id++;
      city.label = city.name;
      city.leaf = (city.children || []).length == 0;
      for (var k = 0; k < (city.children || []).length; k++) {
        var area = city.children[k];
        var obj = {
          value: id++,
          label: String(area).toString(),
          leaf: true
        }
        city.children[k] = obj;
      }
    });
  });
  return list;
}
$.extend({
    applyIf: function (object, config) {
      var property;
      if (object) {
        for (property in config) {
          if (object[property] === undefined) {
            if (this.isPlainObject(config[property])) {
              object[property] = this.applyIf({}, config[property]);
            } else {
              object[property] = config[property];
            }
          }
        }
      }

      return object;
    },
    valInArray: function (arr, val) {
      var idx = -1;
      this.each(arr, function (i, item) {
        if (item == val) {
          idx = i;
          return false;
        }
      });
      return idx > -1;
    },
    uniqueArray: function (arr) {
      var new_arr = [];
      for (var i = 0; i < arr.length; i++) {
        var items = arr[i];
        if (!$.valInArray(new_arr, items)) {
          new_arr.push(items);
        }
      }
      return new_arr;
    },
    mergeValueArray: function (arr) {
      var data = {};
      this.each(arr, function (i, obj) {
        if (data.hasOwnProperty(obj.name)) {
          data[obj.name] = $.makeArray(data[obj.name]).concat(obj.value);
        } else {
          data[obj.name] = obj.value;
        }
      })
      return data;
    },
    getFieldVal(obj, path, def) {
      if (!obj || path == undefined) {
        return def == undefined ? '' : def;
      }
      var pointer = obj, arrpath = String(path).split('.');
      for (var i = 0; i < arrpath.length; i++) {
        var obj1 = arrpath[i];
        if (pointer[obj1] != undefined) {
          pointer = pointer[obj1];
        } else {
          return def == undefined ? '' : def;
        }
      }
      return pointer
    },
    pluck: function (arr, field, putempty) {
      var retarr = [];
      var val;
      if ($.isArray(arr)) {
        $.each(arr, function (i, item) {
          if ($.isPlainObject(item)) {
            val = $.getFieldVal(item, field);
            if (putempty == false) {
              val && retarr.push(val);
            } else {
              retarr.push(val);
            }
          }
        })
      } else if ($.isPlainObject(arr)) {
        for (var k in arr) {
          var item = arr[k];
          if ($.isPlainObject(item)) {
            val = $.getFieldVal(item, field);
            if (putempty == false) {
              val && retarr.push(val);
            } else {
              retarr.push(val);
            }
          }
        }
      }
      return retarr;
    },
    isEmpty: function (val) {
      var type = this.type(val);
      if (type == "object") {
        return this.isEmptyObject(val);
      } else if (type == "array") {
        return val.length == 0;
      } else if (type == "string") {
        return val == null || val == undefined || val == "";
      } else {
        return val == null || val == undefined || Number.isNaN(val);
      }
    },
    isString: function (val) {
      var type = this.type(val);
      if (type == "string") {
        return true;
      } else {
        return false;
      }
    },
    fromQueryString: function (queryString, recursive, parseEmpty) {
      var parts = queryString.replace(/^\?/, '').split('&'),
        object = {},
        temp, components, name, value, i, ln,
        part, j, subLn, matchedKeys, matchedName,
        keys, key, nextKey;

      for (i = 0, ln = parts.length; i < ln; i++) {
        part = parts[i];

        if (part.length > 0) {
          components = part.split('=');
          name = decodeURIComponent(components[0]);
          value = (components[1] !== undefined) ? decodeURIComponent(components[1]) : '';
          if (parseEmpty) {
            value = (value == '{}') ? {} : (value == '[]') ? [] : value;
          }
          if (!recursive) {
            if (object.hasOwnProperty(name)) {
              if (!$.isArray(object[name])) {
                object[name] = [object[name]];
              }

              object[name].push(value);
            }
            else {
              object[name] = value;
            }
          }
          else {
            matchedKeys = name.match(/(\[):?([^\]]*)\]/g);
            matchedName = name.match(/^([^\[]+)/);

            //<debug error>
            if (!matchedName) {
              throw new Error('[fromQueryString] Malformed query string given, failed parsing name from "' + part + '"');
            }
            //</debug>

            name = matchedName[0];
            keys = [];

            if (matchedKeys === null) {
              object[name] = value;
              continue;
            }

            for (j = 0, subLn = matchedKeys.length; j < subLn; j++) {
              key = matchedKeys[j];
              key = (key.length === 2) ? '' : key.substring(1, key.length - 1);
              keys.push(key);
            }

            keys.unshift(name);

            temp = object;

            for (j = 0, subLn = keys.length; j < subLn; j++) {
              key = keys[j];

              if (j === subLn - 1) {
                if ($.isArray(temp) && key === '') {
                  temp.push(value);
                }
                else {
                  temp[key] = value;
                }
              }
              else {
                if (temp[key] === undefined || typeof temp[key] === 'string') {
                  nextKey = keys[j + 1];

                  temp[key] = ($.isNumeric(nextKey) || nextKey === '') ? [] : {};
                }

                temp = temp[key];
              }
            }
          }
        }
      }

      return object;
    }
  }
);
Object.defineProperties(Date.prototype, {
  "format": {
    value: function (fmt) { //author: meizz
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
  }
})
Object.defineProperties(String.prototype, {
  "format": {
    value: function () {
      var args = $.makeArray(arguments);
      return this.replace(/\{(\d+)\}/g, function (m, i) {
        return args[i * 1 - 1];
      });
    }
  },
  // 所有参数都有值时才替换否则直接返回空
  "hformat": {
    value: function () {
      var args = $.makeArray(arguments);
      for (var i = 0; i < args.length; i++) {
        var obj = args[i];
        if (obj === undefined || obj === '' || obj === null || Number.isNaN(obj)) {
          return '';
        }
      }
      return this.replace(/\{(\d+)\}/g, function (m, i) {
        return args[i * 1 - 1];
      });
    },
  },
  //不存在转成空值
  "eformat": {
    value: function () {
      var args = $.makeArray(arguments);
      return this.replace(/\{(\d+)\}/g, function (m, i) {
        var obj = args[i * 1 - 1];
        if (obj === undefined || obj === '' || obj === null || Number.isNaN(obj)) {
          return '';
        }
        return obj;
      });
    }
  }
})
Object.defineProperties(Array.prototype, {
  "unique": {
    value: function (field, clone) {
      var newarr = [];
      var po = {};
      for (var i = 0; i < this.length; i++) {
        var item = this[i];
        var val = '';
        if (field) {
          val = item[field];
        } else {
          val = item;
        }
        if (!po.hasOwnProperty(val)) {
          po[val] = true;
          if (clone) {
            newarr.push(item);
          }
        } else {
          if (!clone) {

            this.splice(i, 1);
            i--;
          }
        }
      }
      if (clone) {
        return newarr;
      } else {
        return this;
      }

    }
  }
})
Object.defineProperties(Number.prototype, {
  "_rightJoin": {
    value: function (string, size, character) {
      var result = String(string);
      character = character || "0";
      while (result.length < string.length + size) {
        result = result + character;
      }
      return result;
    }
  },
  "_accFloat": {
    value: function (oper, arg2) {
      // 不要用内部函数来，影响效率
      // this.rightJoin = function (string, size, character) {}
      var n1 = (this || '').toString(), n2 = (arg2 || '').toString(), n1PointValue = n1
            .split(".")[1]
          || '', // 小数部分
        n2PointValue = n2.split(".")[1] || '', n1PointLen = n1PointValue.length, // 小数位数
        n2PointLen = n2PointValue.length, maxPointLen = n1PointLen >= n2PointLen
          ? n1PointLen
          : n2PointLen, // 最高位数
        powValue = Math.pow(10, maxPointLen), // 精度调整
        result = NaN;
      n1 = this._rightJoin(n1, maxPointLen - n1PointLen); // 补齐小数位使两者小数位相同
      n2 = this._rightJoin(n2, maxPointLen - n2PointLen);
      n1 = n1.replace('.', ''); // 去掉小数点
      n2 = n2.replace('.', '');
      switch (oper) {
        case '+' : {
          // 100.1+0.06 = (100.1+0.06)*100/100 = (100.1*100 +
          // 0.06*100)/100
          result = (Number(n1) + Number(n2)) / powValue;
          break;
        }
        case '-' : {
          // 100.1-0.06 = (100.1-0.06)*100/100 = (100.1*100 -
          // 0.06*100)/100
          result = (Number(n1) - Number(n2)) / powValue;
          break;
        }
        case '*' : {
          // 100.1*0.06 = (100.1*0.06)*100^2/100^2 = (100.1*100 *
          // 0.06*100)/100^2
          result = (Number(n1) * Number(n2)) / Math.pow(powValue, 2);
          break;
        }
        case '/' : {
          // 100.1/0.06 = (100.1/0.06)*100/100 = (100.1*100 /
          // 0.06*100)
          result = Number(n1) / Number(n2);
          break;
        }
        case '%' : {
          // 100.1%0.06 = (100.1%0.06)*100/100 = (100.1*100 %
          // 0.06*100)
          result = Number(n1) % Number(n2);
          break;
        }
        default : {
          break;
        }
      }
      return Number(result);
    }
  },
  "add": {
    value: function (arg) {
      return this._accFloat('+', arg);
    }
  },
  "sub": {
    value: function (arg) {
      return this._accFloat('-', arg);
    }
  },
  "mul": {
    value: function (arg) {
      return this._accFloat('*', arg);
    }
  },
  "div": {
    value: function (arg) {
      return this._accFloat('/', arg);
    }
  },
  "mod": {
    value: function (arg) {
      return this._accFloat('%', arg);
    }
  },
})
Object.getFields=function (obj, prefix = '', result = []) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newPath = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null ) {
        Object.getFields(obj[key], newPath, result);
      } else {
        result.push(newPath);
      }
    }
  }
  return result;
}
Object.deepEqual=function (obj1, obj2) {
  // 如果两个值相同（包括都是null），则认为它们相等
  if (obj1 === obj2) return true;

  // 如果其中一个值不是对象，或者两个值都不是对象，则它们不相等
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false;
  }

  // 获取两个对象的属性名数组
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // 如果属性数量不同，则对象不相等
  if (keys1.length !== keys2.length) return false;

  // 遍历obj1的属性，检查每个属性是否也在obj2中，并且值相等
  for (const key of keys1) {
    if (!keys2.includes(key) || !Object.deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  // 如果所有属性都检查通过，则对象相等
  return true;
}
export default {
  Editors:Editors,
  Checker: Checker,
  Reger: Reger,
  ajax: ajax,
  back(path){
    path && this.$router.push(path);
    this.$router.back();
  },
  callParent(id, fn){
    var parent = this.getVue(id);
    return function () {
      fn.apply(parent, arguments);
    }
  },
  setVue(name){
    $(document).data(name, this);
    $(document).data("_currentPageVue", this);
  },
  error(msg, dur){
    if ($.isPlainObject(msg)) {
      this.$message.error(msg);
    } else {
      this.$message.error({duration: dur || 2000, message: msg, customClass: 'msgboxclass'});
    }

  },
  warning(msg, dur){
    if ($.isPlainObject(msg)) {
      this.$message.warning(msg);
    } else {
      this.$message.warning({duration: dur || 500, message: msg, customClass: 'msgboxclass'});
    }
  },
  okmsg(msg='操作成功', dur){
    if ($.isPlainObject(msg)) {
      this.$message.success(msg);
    } else {
      this.$message.success({duration: dur || 1000, message: msg == 'success' ? '操作成功' : msg, customClass: 'msgboxclass'});
    }
  },
  msg(msg, dur){
    if ($.isPlainObject(msg)) {
      this.$message(msg);
    } else {
      this.$message.info({duration: dur || 1000, message: msg == 'success' ? '操作成功' : msg, customClass: 'msgboxclass'});
    }
  },
  confirm(msg, cbk, title, cfg){
    this.$confirm(msg, title || '提示', $.extend(true, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }, cfg)).then(cbk).catch((err) => {
      err=='cancel'?this.msg('已取消操作'):this.error(err.message);
    });
  },
  confirm(msg, cbk,buttons ,title, cfg){
    this.$confirm(msg, title || '提示', $.extend(true,buttons, cfg)).then(cbk).catch((err) => {
      err=='cancel'?this.msg('已取消操作'):this.error(err.message);
    });
  },
  prompt(msg, cbk, title, cfg){
    this.$prompt(msg, title || '提示', $.extend(true, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /.+/,
      inputErrorMessage: '不能为空'
    }, cfg)).then(cbk).catch((err) => {
      err=='cancel'?this.msg('已取消操作'):this.error(err.message);
    });
  },
  getVue(name){
    return $(document).data(name)
  },
  isArray(arr){
    return $.isArray(arr);
  },
  makeArray(obj){
    return $.makeArray(obj);
  },
  removeEmptyField(obj) {
    if ($.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        if ($.isEmpty(obj[i])) {
          obj.splice(i, 1);
          i--;
        }
      }
    } else {
      for (var k in obj) {
        if ($.isEmpty(obj[k])) {
          delete obj[k];
        }
      }
    }
    return obj;
  },
  toDateString(dt, fr){
    var o = new Date(dt || new Date);
    return o.format(fr || 'yyyy-MM-dd hh:mm:ss');
  },
  getDay(dif){
    return new Date(Number(new Date()) + (!dif ? 0 : dif) * 24 * 60 * 60 * 1000);
  },
  getFieldVal(obj, path, def) {
    if (!obj || path == undefined) {
      return def == undefined ? '' : def;
    }
    var pointer = obj, arrpath = String(path) ? String(path).split('.') : [];
    for (var i = 0; i < arrpath.length; i++) {
      var obj1 = arrpath[i];
      if (pointer[obj1] != undefined) {
        pointer = pointer[obj1];
      } else {
        return def == undefined ? '' : def;
      }
    }
    return pointer
  },
  setFieldVal(obj, path, val, create) {
    if (!obj || path == undefined) {
      return obj;
    }
    var pointer = obj, arrpath = String(path) ? String(path).split('.') : [];
    for (var i = 0; i < arrpath.length; i++) {
      var obj1 = arrpath[i];
      if (i == arrpath.length - 1) {
        pointer[obj1] = val;
      } else {
        if (pointer.hasOwnProperty(obj1)) {
          pointer = pointer[obj1];
        } else if (create) {
          pointer = pointer[obj1] = {};
        } else {
          return obj;
        }
      }
    }
    return pointer;
  },
  toPage(path, param){
    // var data = this.setPageParam(path, param  );
    // data.jumpQuery && (data.jumpQuery = JSON.stringify(data.jumpQuery));
    // console.log(data);
    this.$router.push({path: path.replace('.vue', ''), query: param});
  },
  toPageParam(path, query,param){
    console.log(param);
    // var data = this.setPageParam(path, param  );
    // data.jumpQuery && (data.jumpQuery = JSON.stringify(data.jumpQuery));
    // console.log(data);
    this.$router.push({path: path.replace('.vue', '') ,params: param  });
  },
  clearJump(){
    var cur = this.$route.path.replace('/', '').replace('.vue', '');
    delete this.paramObj.jumpQuery;
    this.removePageParam(cur);
    this.toPage(cur, this.paramObj);
    this.getVue('layoutvue').reload();
  },
  jumptoMenu(path, param){
    this.$emit('jumpfrom', {
      path: path,
      param: param
    });
  },
  toBack(){
    this.$router.back();
  },
  //不使用eval将非标准json字符串转成对象
  toJSON(str, errdef){
    var obj = errdef || {};
    if (str) {
      try {
        obj = new Function('return ' + str)();
      } catch (err) {
        // console.error('toJSON格式化错误:' + str);
      }
    }
    return obj;
  },
  removePageParam(pagename){
    var pname = pagename.replace('.vue', '') || "pagedata";
    Vue.ls.remove(pname);
  },
  setPageParam(pagename, value, path) {
    var pname = pagename.replace('.vue', '') || "pagedata";
    var data = Vue.ls.get(pname) || {};
    $.extend(true, data, value);
    Vue.ls.set(pname, data);
    return data;
  },
  getPageParam(pagename, path) {
    var pname = pagename.replace('.vue', '') || "pagedata";
    var data = Vue.ls.get(pname);
    // data=this.toJSON(data);
    return path ? this.getFieldVal(data, path) : data;
  },
  getToken(to){
    if (to && to.query && to.query.token) {
      Vue.ls.set('user', {});
      Vue.ls.set('token', to.query.token);
    }
    return Vue.ls.get('token');
  },
  onSubmit(submittype) {
  },
  onInit(){
  },
  uploadSuccess(res, file, filelist) {
    file.url = this.getFieldVal(res, 'data.url');
  },
  showPicDialog(url){
    var d = $.isPlainObject(url) ? (url.url) : url;
    this.getVue('layoutvue').showPicDialog(d);
  },
  showVideoDialog(url, oss){
    var d = $.isPlainObject(url) ? (url.url) : url;
    this.getVue('layoutvue').showVideoDialog(d, oss);
  },
  getVideoUrl(id, fun, lev){
    if ($.isEmpty(id)) {
      this.warning('视频ID不能为空');
      return;
    }
    ajax("post", {alivod_id: id}, 'common/alivod/getplayinfo', (res) => {
      if (res.error_code == '0') {
      } else {
        this.error(String(res.message));
      }
      fun(this.getFieldVal(res, 'data.play_info.{1}.PlayURL'.format(lev || 1), ''));
    });
  },
  reloadPage(){
    this.getVue('layoutvue').reload()
  },

  cutdown(second = 60, cbk) {
    setTimeout(() => {
      second--;
      if (second == 0) {
        $.isFunction(cbk) && cbk(second);
      } else {
        $.isFunction(cbk) && cbk(second);
        this.cutdown(second, cbk);
      }
    }, 1000);
  },
  getRemoteSelectSearchMethod(name)
  {
    var that = this;
    var newarg = $.makeArray(arguments);
    return function (query) {
      newarg.splice(1, 0, query);//name,query,....
      that.remoteSelectSearchMethod.apply(that, newarg);
    }
  },
  getRemoteCascader(name, type){
    var that = this;
    return function (node, resolve) {
      that.remoteCascaderSearchMethod(name, type, node, resolve);
    }
  },
  setNodeInfo(list, idfield, namefield, childfield){
    $.each(list, (i, item) => {
      item.value = item[idfield || 'id'];
      item.label = item[namefield || 'name'];
      item.leaf = item[childfield || 'children'].length == 0;
      if (item[childfield || 'children'].length) {
        this.setNodeInfo(item[childfield || 'children'], idfield, namefield, childfield);
      } else {
        delete item[childfield || 'children'];
      }
    });
    return list;
  },
  remoteCascaderSearchMethod(name, type, node, resolve){
  },
  remoteSelectSearchMethod(name, query)
  {
  },
  getCityDeep(tree, deep){
    var copy = $.extend(true, [], tree);
    if (deep == 1) {
      for (var i = 0; i < copy.length; i++) {
        delete copy[i].children;
      }
    }
    if (deep = 2) {
      for (var i = 0; i < copy.length; i++) {
        for (var j = 0; j < (copy[i].children || []).length; j++) {
          delete copy[i].children[j].children;
        }
      }
    }
    return copy;
  },
  // list为离散节点数组即还没拼好父子关系
  getNode(list, parnode, idfield, parfield, childrenfield) {
    parnode[childrenfield] = parnode[childrenfield] || [];
    for (var i = 0; i < list.length; i++) {
      var child = list[i];
      child.expanded = true;
      child.nodeParentId = child[parfield];
      child.nodeId = child[idfield];
      child.nodeLeaf = true;
      child.nodeInited = true;
      if (child[parfield] == parnode[idfield]) {
        child.nodePath = (parnode.nodePath || 0) + '/' + child.nodeId;
        child.nodeIndex = parnode[childrenfield].length;
        child.indexPath = (parnode.indexPath || 0) + '/' + child.nodeIndex;
        child = this.getNode(list, child, idfield, parfield, childrenfield);
        if (child.hasOwnProperty(childrenfield)) {
          child.nodeLeaf = false;
        }
        parnode[childrenfield].push(child);
      }
    }
    if (parnode[childrenfield].length == 0) {
      delete parnode[childrenfield];
    }
    return parnode;
  },
  // list为节点数组，即父子关系已经拼好，结构不能变
  initNodeInfo(list, parnode, idfield, parfield, childrenfield) {
    parnode[childrenfield] = parnode[childrenfield] || [];
    for (var i = 0; i < list.length; i++) {
      var child = list[i];
      child.expanded = true;
      child.nodeParentId = child[parfield];
      child.nodeId = child[idfield];
      child.nodeLeaf = true;
      child.nodeInited = true;
      if (child[parfield] == parnode[idfield]) {
        child.nodePath = (parnode.nodePath || 0) + '/' + child.nodeId;
        child.nodeIndex = i;
        child.indexPath = (parnode.indexPath || 0) + '/' + child.nodeIndex;
        child = this.initNodeInfo(child[childrenfield] || [], child, idfield, parfield, childrenfield);
        if (child.hasOwnProperty(childrenfield)) {
          child.nodeLeaf = false;
        }
      }
    }
    if (parnode[childrenfield].length == 0) {
      delete parnode[childrenfield];
    }
    return parnode;
  },
  eachNode(nodelist,nextfield,cbk){
    for (var i = 0; i < nodelist.length; i++) {
      var cur = nodelist[i];
      if(cbk(cur)!=false){
        this.eachNode(cur[nextfield]||[],nextfield,cbk);
      }else{
        break;
      }
    }
  },
  appendPicParam(obj, path){
    var param = {};
    param = '?mage/auto-orient,1/interlace,1/quality,q_90/format,jpg';
    if ($.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        var obj1 = obj[i];
        var old = this.getFieldVal(obj1, path, '');
        old && this.setFieldVal(obj1, path, old + param);
      }
    } else if ($.isPlainObject(obj)) {
      var old = this.getFieldVal(obj, path, '');
      old && this.setFieldVal(obj, path, old + param);
    }
  },
  getParent(obj, pfield, pkey, ckey){
    var arr = [obj[ckey || 'id']];
    var pobj = obj[pfield];
    if (!pobj) {
      return arr;
    }
    return arr.concat(this.getParent(pobj, pfield, pkey, ckey));
  },
  getPathArr(obj, childrenfield, pathfield, endfield, endval){
    var arr = [];
    for (var i = 0; i < (obj||[]).length; i++) {//防止手多传了children字段却是null
      var node = obj[i];
      if (node[endfield] == endval) {
        arr.push(node[pathfield]);
        break;
      }
      if (node.hasOwnProperty(childrenfield)) {
        var children = node[childrenfield];
        var havechild = this.getPathArr(children, childrenfield, pathfield, endfield, endval);
        if (havechild.length > 0) {
          arr.push(node[pathfield]);
          arr = arr.concat(havechild);
        }
      }
    }
    return arr;
  },
  removePicParam(obj, path){
    var param = {};
    param = '?mage/auto-orient,1/interlace,1/quality,q_90/format,jpg';
    if ($.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        var obj1 = obj[i];
        var old = this.getFieldVal(obj1, path, '');
        old && this.setFieldVal(obj1, path, old.substr(0, old.indexOf(param)));
      }
    } else if ($.isPlainObject(obj)) {
      var old = this.getFieldVal(obj, path, '');
      old && this.setFieldVal(obj, path, old.substr(0, old.indexOf(param)));
    } else if (typeof obj == 'string') {
      return obj.substr(0, obj.indexOf(param));
    }
  },
  findArrayItem(arr, val, key){
    var ret = false, idx = -1;
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i];
      var v1, v2;
      if (key) {
        v1 = obj[key];
        v2 = val;
      } else {
        v1 = obj;
        v2 = val;
      }
      if (v1 == v2) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      return {index: idx, data: arr[idx]};
    } else {
      return undefined;
    }
  },
  findNode(arr, childrenfield, keyfield, keyval, justleaf){
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (item[keyfield] == keyval) {
        if (justleaf&&item.hasOwnProperty(childrenfield)) {

        }else{
          return item;
        }
      }
      var child = this.findNode(item[childrenfield] || [], childrenfield, keyfield, keyval);
      if (child != false) {
        return child;
      }
    }
    return false;
  },
  removeItemByKey(arr, childrenfield, keyfield, keyval){
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (item[keyfield] == keyval) {
        arr.splice(i, 1);
        return;
      }
      this.removeItemByKey(item[childrenfield] || [], childrenfield, keyfield, keyval);
    }
  },
  removeArrayItem(arr, item, key){
    var val, idx = -1;
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i];
      var v1, v2;
      if (key) {
        v1 = obj[key];
        v2 = item[key];
      } else {
        v1 = obj;
        v2 = item;
      }
      if (v1 == v2) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      arr.splice(idx, 1);
    }
  },
  getDefData(){
    var id = String(Number(new Date()));
    this.setVue(id);
    var param = $.extend(true, {}, this.getPageParam(this.$route.path.substr(1)), this.$route.query || {id: ''});
    return {
      vueid: id,
      dataId: param.id || '',
      paramObj: param,
      uploadUrl: hUrl + 'common/upload',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      query: {},
      form: {},
      rules: {},
      tableCfg: {},
      loading: false,
      loadedStatus: {},
      selectOpts: {},
      //cityTree: CityTree
    }
  },
  getTableDefCfg(cfg) {
    var def = {
      where: {token: localStorage.token}
      , method: 'post'
      , remote: true
      , page: true //开启分页,
      , currentpage: 1
      , pageConfig: {
        pagesize: 50,
        total: 0,
        layout: 'total, prev, pager, next'
      }
      , request: {
        pageName: 'page' //页码的参数名称，默认：page
        , limitName: 'per_page' //每页数据量的参数名，默认：limit
        , page: 1
        , pagesize: cfg.pageSize || 50
      }
      , response: cfg.page ? {
        statusName: 'error_code' //数据状态的字段名称，默认：code
        , statusCode: '0' //成功的状态码，默认：0
        , msgName: 'error_msg' //状态信息的字段名称，默认：msg
        , countName: 'data.total' //数据总数的字段名称，默认：count
        , dataName: 'data.data' //数据列表的字段名称，默认：data
      } : {
        statusName: 'error_code' //数据状态的字段名称，默认：code
        , statusCode: '0' //成功的状态码，默认：0
        , msgName: 'error_msg' //状态信息的字段名称，默认：msg
        , countName: 'data.length' //数据总数的字段名称，默认：count
        , dataName: 'data' //数据列表的字段名称，默认：data
      },
      lastSearch: {},
      selected: [],
      onSelectChange: function (selection) {
        this.selected = selection;
      },
      getSelected: function () {
        return this.selected;
      },
      toPage: function (page, ajaxCfg, vue, cbk) {
        this.loadPage(page, ajaxCfg || this.lastSearch[0], vue || this.lastSearch[1], cbk || this.lastSearch[2]);
      },
      loadPage: function (page, ajaxCfg, vue, cbk) {
        var p = {};
        p[this.request.pageName] = page;
        p[this.request.limitName] = this.request.pagesize;
        this.currentpage = page;
        this.load($.extend(true, {}, ajaxCfg, this.where, {param: p}), vue, cbk);
      },
      load: function (ajaxCfg, vue, cbk) {
        var that = this;
        vue.loading = true;
        this.lastSearch = [ajaxCfg, vue, cbk];
        ajax(ajaxCfg.method || this.method || "get", ajaxCfg.param || {}, ajaxCfg.url || this.url, function (res) {
          cbk && $.isFunction(cbk) && cbk(res);
          if (vue.getFieldVal(res, that.response.statusName) == '0') {
            that.pageConfig.total = vue.getFieldVal(res, that.response.countName);
            that.data = vue.getFieldVal(res, that.response.dataName);
          } else {
            // vue.$message(String(vue.getFieldVal(res, that.response.msgName)));
          }
          vue.loading = false;
        }, false, undefined, function (xhr) {
          var res = xhr.responseText && JSON.parse(xhr.responseText) || {message: ''};
          vue.$message({message: String(xhr.statusText) + res.message, type: 'error', showClose: true});
          vue.loading = false;
        });
      },
      reload: function () {
        this.load(this.lastSearch[0], this.lastSearch[1], this.lastSearch[2]);
      },
      onloaded: function (reqAjax, result) {

      },
      done: function (loaded, page, count) {
      }
    };
    return $.extend(true, {}, def, cfg);
  },
  createJumpLink(url, obj, text, tag) {
    return '<a style="color: #199ed8;" href="{1}?{2}" {4}>{3}</a>'.format(url, $.param(obj), text, tag || '');
  },
  addBracket(data, retobj, pre, deep) {
    if ($.isPlainObject(data) || $.isArray(data)) {
      for (var key in data) {
        var nkey = pre + '[{1}]'.format(key);
        if (deep && ($.isPlainObject(data[key]) || $.isArray(data[key]))) {
          this.addBracket(data[key], retobj, nkey)
        } else {
          retobj[nkey] = data[key];
        }
      }
    }
    return retobj;
  },
  addEditStatus(raw, statusname, path) {
    var data = path ? this.getFieldVal(raw, path) : raw;
    for (var key in data) {
      raw[(statusname || 'edit') + "_" + key] = data[key];
    }
  }, removeEditStatus(raw, statusname) {
    var obj = {};
    for (var key in raw) {
      var fieldname = (statusname || 'edit') + '_';
      if (key.startsWith(fieldname)) {
        delete raw[key];
      }
    }
    return obj;
  }, getEditData(raw, statusname) {
    var obj = {};
    for (var key in raw) {
      var fieldname = (statusname || 'edit') + '_';
      var newfieldname = key.replace(fieldname, '');
      if (key.startsWith(fieldname)) {
        obj[newfieldname] = raw[key];
      }
    }
    return $.extend(true, {}, obj);
  },
  isFunction(arg){
    return $.isFunction(arg);
  },
  toFixed(val, len){
    var ab = Math.pow(10, len || 2);
    var dw = Math.round(val * ab) / ab;
    return dw;
  },
  getTreeDeep(tree, childfield, deep, cur){
    for (var i = 0; i < tree.length; i++) {
      var obj = tree[i];
      if ((cur || 0) < deep) {
        if (obj.hasOwnProperty(childfield)) {
          this.getTreeDeep(obj[childfield], childfield, deep, (cur || 0) + 1);
          if (obj[childfield].length == 0) {
            delete obj[childfield];
          }
        }
      } else {
        tree.splice(i, 1);
        i--;
      }
    }
    return tree;
  }, getwidthname: function (col) {
    // `this` 指向 vm 实例
    return col.flex ? 'min-width' : 'width';
  },
  resetCols: function (tableCfg, cols) {
    tableCfg.cols = [];
    this.$nextTick(function () {
      tableCfg.cols = cols;
    })
  },
  resetObj(data, emptyval) {
    var ret;
    if ($.isPlainObject(data)) {
      ret = $.extend(true, {}, data);
      for (var k in data) {
        ret[k] = emptyval || "";
      }
    } else if ($.isArray(data)) {
      ret = $.extend(true, [], data);
      for (var i = 0; i < data.length; i++) {
        ret[i] = emptyval || "";
      }
    } else {
      ret = emptyval || "";
    }
    return ret;
  },
  convertToNum: function (val) {
    if ($.isArray(val)) {
      var newarr = [];
      for (var i = 0; i < val.length; i++) {
        var obj = val[i];
        newarr.push(Number(obj));
      }
      return newarr;
    }
    return Number(val);
  },
  isEmpty(v){return $.isEmpty(v)}
}



// WEBPACK FOOTER //
// ./src/utils/index.js